import { Elements } from '@stripe/react-stripe-js';
import { getStripeInstance } from 'utils/stripe';

const stripe = await getStripeInstance();

const withStripeElements = (Component) => (props) => (
  <Elements stripe={stripe}>
    <Component {...props} />
  </Elements>
);

export default withStripeElements;
